import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import useCrmObjectTypeName from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NavItemTooltip({
  disabled,
  selectedAssetCount,
  children
}) {
  const {
    objectTypeNamePlural,
    objectTypeNameSingular
  } = useCrmObjectTypeName();
  return /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": 'nav-item-tooltip',
    title: I18n.text('frameworkListingLib.folders.moveAssetsModal.footer.moveTooltip', {
      count: selectedAssetCount || 0,
      objectTypeName: objectTypeNameSingular,
      objectTypeNamePlural
    }),
    disabled: disabled,
    children: children
  });
}